import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="speaker-filter"
export default class extends Controller {
  static targets = ["form", "input", "clear"]

  connect() {
    this.toggle()
    this._timeout = null
  }

  disconnect() {
    clearTimeout(this._timeout)
  }

  change() {
    this.submit()
  }

  onInput() {
    this.toggle()
    this.debounceSubmit()
  }

  toggle() {
    const hasText = (this.inputTarget?.value || "").trim().length > 0
    if (this.hasClearTarget) {
      this.clearTarget.classList.toggle("hidden", !hasText)
    }
  }

  clear() {
    if (!this.hasInputTarget) return
    this.inputTarget.value = ""
    this.toggle()
    this.submit()
  }

  debounceSubmit() {
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this.submit(), 300)
  }

  submit() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
